import { Card, Classes, NonIdealState } from "@blueprintjs/core";
import React, { useRef } from "react";

import Viewboard from "../../components/DrawingBoard/viewboard";
import { Printable } from "../../components/printable/printable";
import { SportPlay } from "../../types";
import styles from "./play-viewer.module.scss";

export interface PlayViewerProps {
  activeDrawPlay?: SportPlay | null;
  isLoading: boolean;
  handleClickEditPlay: () => void;
}

export const PlayViewer = ({ activeDrawPlay, isLoading, handleClickEditPlay }: PlayViewerProps) => {
  const componentRef = useRef<HTMLDivElement | null>(null);

  if (isLoading) {
    return <LoadingPlayViewer />;
  }

  if (!activeDrawPlay) {
    return <NoPlaySelected />;
  }

  return (
    <Printable ref={componentRef} style={{ maxHeight: "100%", display: "flex" }}>
      <Card className={styles.card}>
        {activeDrawPlay && (
          <Viewboard
            activePlay={activeDrawPlay}
            handleClickEditPlay={handleClickEditPlay}
            printableRef={componentRef}
          />
        )}
      </Card>
    </Printable>
  );
};

const LoadingPlayViewer = () => {
  return (
    <div>
      <Card className={styles.card}>
        <h5 style={{ marginTop: "20px" }}>
          <span className={Classes.SKELETON} style={{ height: "30px", width: "80px" }}>
            filler
          </span>
          •
          <span className={Classes.SKELETON} style={{ height: "30px", width: "130px" }}>
            {" "}
            fillerrrrrrrrr{" "}
          </span>{" "}
          •
          <span className={Classes.SKELETON} style={{ height: "30px", width: "100px" }}>
            {" "}
            fillerrrrrrrrrrrrrrr{" "}
          </span>{" "}
          •
          <span className={Classes.SKELETON} style={{ height: "30px", width: "110px" }}>
            {" "}
            fillerrrrrrrrrrrrrrrrrrrrrrrrrrr{" "}
          </span>
        </h5>
        <div className={styles.courtTableContainer}>
          <div className={styles.row}>
            <div className={styles.courtRowContainer}>
              <div className={Classes.SKELETON} style={{ width: "100%", height: "500px" }} />
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

const NoPlaySelected = () => {
  return (
    <NonIdealState
      icon={"square"}
      title={"No Play Selected"}
      description={"Select a Play from the list to view it."}
      layout={"vertical"}
    />
  );
};
